var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.$route.params.formName === 'newSoftwareForm')?_c('NewSoftwareForm'):(_vm.$route.params.formName === 'modifySoftwareForm')?_c('ModifySoftwareForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }